module.exports = "/_next/static/images/18-e93799fdc1826733470a2876062a9600.png";